module.exports = __webpack_public_path__ + "img/浙商.deb918a9.png";